import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { hotArticles } from '@/mocks/siteData';

const articleContents: Record<number, { content: string; tags: string[] }> = {
  1: {
    content: `据知情人士透露，某当红顶流男星近期频繁出入北京某高端酒店，与一位神秘女子同进同出，引发广泛关注。记者连续蹲点多日，多次拍到两人深夜同框画面。

据酒店工作人员透露，该男星已在此酒店长包了一间总统套房，每周至少入住三天。而那位神秘女子每次都从地下车库直接进入，疑似刻意躲避媒体镜头。

有趣的是，这位神秘女子与男星此前在某品牌活动中有过合作，当时两人互动就颇为亲密，被眼尖的网友发现后引发过热议。当时双方团队都否认恋情，称只是正常的工作交流。

但这次被拍到的画面显然超出了"工作交流"的范畴。有目击者称，两人在酒店大堂等电梯时举止亲密，男星还贴心地为女方整理头发，完全不像是普通朋友关系。

业内人士分析，该男星近年来事业蒸蒸日上，但私生活一直非常低调。如果这次恋情坐实，将是其出道以来首次公开承认恋情。不过考虑到其粉丝群体以女友粉为主，公开恋情可能面临较大的舆论压力。

截止发稿前，记者已联系男星工作室求证，但对方暂未回应。我们将持续关注事件进展。`,
    tags: ["爆料", "明星恋情", "独家", "顶流男星", "酒店密会"]
  },
  2: {
    content: `拥有千万粉丝的知名网红"甜心教主"近日遭遇人设崩塌危机。多名前员工集体发声，揭露其背后的真实面目，引发粉丝大规模脱粉。

据悉，最先站出来爆料的是曾在该网红团队工作两年的前助理。她详细描述了工作期间的种种遭遇：拖欠工资、随意辱骂员工、要求员工24小时待命、禁止员工谈恋爱等。更令人震惊的是，该网红在镜头前展现的"善良温柔"形象与私下判若两人。

随后，又有三名前员工通过社交媒体分享了类似的经历，包括被克扣年终奖、被要求做与工作内容无关的私人事务等。这些爆料迅速在网络上发酵，话题阅读量在24小时内突破3亿。

品牌方反应迅速。截至目前，已有5家与该网红有合作关系的品牌发布声明，宣布终止代言合作。其中一家国际美妆品牌的公关负责人表示："我们对此事非常重视，已启动内部调查程序。"

该网红本人目前暂未公开发声，但其工作室发布了一则简短声明，称"相关爆料存在不实信息，将保留法律追究权利"。然而，这则声明并未平息舆论，反而引发了更多的质疑声。`,
    tags: ["网红", "人设崩塌", "员工爆料", "品牌解约", "粉丝脱粉"]
  },
  3: {
    content: `某热门综艺节目在最新一期录制过程中突发意外状况，导致录制被迫中断近两个小时，导演组紧急叫停并进行内部讨论。

据现场观众透露，当天录制的是一个竞技类游戏环节，需要嘉宾们完成一系列高难度挑战。但在进行到第二关时，由于道具设置存在安全隐患，一位嘉宾在跳跃过程中意外摔倒，虽然及时被医务人员搀扶下场，但现场气氛瞬间变得紧张。

更令人意外的是，另一位嘉宾当场对节目组的安全保障提出了质疑，认为游戏环节设计不合理，存在明显的安全漏洞。此言一出，其他几位嘉宾也纷纷表示赞同，场面一度相当尴尬。

导演组随即宣布暂停录制，所有嘉宾被请回休息室。据工作人员透露，导演组和制片人进行了长达一个半小时的紧急会议，讨论后续处理方案。最终决定取消该危险环节，替换为另一个相对安全的游戏。

虽然节目组对外表示"一切正常，只是例行调整"，但多位现场观众已经在社交媒体上分享了事发经过，引发网友热议。有网友扒出该节目此前就曾因安全问题被投诉过，质疑节目组是否真的重视嘉宾安全。`,
    tags: ["综艺", "录制意外", "安全隐患", "嘉宾受伤", "节目争议"]
  }
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id || '1');
  const article = hotArticles.find((a) => a.id === articleId) || hotArticles[0];
  const articleDetail = articleContents[articleId] || articleContents[1] || { content: '暂无详细内容', tags: [] };
  const relatedArticles = hotArticles.filter((a) => a.id !== articleId).slice(0, 3);

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-12 px-4 md:px-8 min-h-screen bg-background-50">
        <article className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <Link to={`/category/${article.category === '明星八卦' ? 'star-gossip' : article.category === '网红爆料' ? 'influencer-expose' : article.category === '综艺八卦' ? 'variety-gossip' : article.category === '影视八卦' ? 'film-gossip' : article.category === '商业八卦' ? 'biz-gossip' : 'industry-gossip'}`} className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">{article.category}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-600 line-clamp-1">{article.title}</span>
          </nav>

          <header className="mb-8">
            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary-500 text-background-50">
                {article.badge}
              </span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                {article.category}
              </span>
            </div>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight text-balance">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 mt-5 text-foreground-400 text-sm flex-wrap">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i>
                {article.author}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {article.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views} 阅读
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-chat-1-line"></i>
                {article.comments} 评论
              </span>
            </div>
          </header>

          <div className="mb-10 rounded-2xl overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-[300px] md:h-[450px] object-cover object-top"
            />
          </div>

          <div className="prose-custom">
            <div className="text-foreground-700 text-base md:text-lg leading-relaxed space-y-6">
              {articleDetail.content.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph.trim()}</p>
              ))}
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <div className="flex flex-wrap items-center gap-2 mb-8">
              <span className="text-foreground-500 text-sm mr-2">标签：</span>
              {articleDetail.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-100 text-foreground-600 cursor-default"
                >
                  #{tag}
                </span>
              ))}
            </div>

            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line text-lg"></i>
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-accent-100 text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line text-lg"></i>
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 text-foreground-600 transition-colors cursor-pointer">
                  <i className="ri-bookmark-line text-lg"></i>
                </button>
              </div>
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <span>声明：本文由社区用户投稿，不代表91吃瓜官方立场</span>
              </div>
            </div>
          </div>

          {relatedArticles.length > 0 && (
            <div className="mt-14 pt-10 border-t border-background-200/70">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">相关爆料</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {relatedArticles.map((rel) => (
                  <Link
                    key={rel.id}
                    to={`/article/${rel.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="relative h-40 rounded-xl overflow-hidden mb-3">
                      <img
                        src={rel.image}
                        alt={rel.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <h3 className="font-heading font-bold text-foreground-950 text-sm leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {rel.title}
                    </h3>
                    <p className="text-foreground-400 text-xs mt-1.5">{rel.date} · {rel.author}</p>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </article>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": article.title,
            "description": article.excerpt,
            "author": { "@type": "Person", "name": article.author },
            "datePublished": article.date,
            "image": article.image,
            "articleSection": article.category,
            "publisher": {
              "@type": "Organization",
              "name": "91吃瓜社区",
              "url": "https://91chigua.com"
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": `https://91chigua.com/article/${article.id}`
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://91chigua.com" },
              { "@type": "ListItem", "position": 2, "name": article.category },
              { "@type": "ListItem", "position": 3, "name": article.title }
            ]
          })}
        </script>
      </main>
      <Footer />
    </>
  );
}